module.exports = __webpack_public_path__ + "1e3d3024552923ee886c97d9fc03c566.svg";